import { render, staticRenderFns } from "./customerManagement.vue?vue&type=template&id=b9f4b95c&scoped=true&"
import script from "./customerManagement.vue?vue&type=script&lang=js&"
export * from "./customerManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f4b95c",
  null
  
)

export default component.exports